import { Box, Button, MenuItem, Paper, Select, TextField, Typography } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import AddIcon from '@mui/icons-material/Add';
import { Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';

import PageSelect from './PageSelect';
import { selectMarkets } from '../../redux/markets/getMarketsSlice';
import { FLAG_MAP, PLACEHOLDER_FLAG } from '../../config/marketFlags';
import { ALL_MARKETS_FALLBACK } from '../../services/flowApiService';

export default function LocatorsFilters({
  form,
  pages,
  loading,
  resultCount,
  onClear,
  onOpenCreate,
  onFilterChange,
}) {
  const markets = useSelector(selectMarkets);
  const visibleMarkets = markets.length > 0 ? markets : ALL_MARKETS_FALLBACK;
  const nameOrValueReg = form.register('nameOrValue');
  const buildReg = form.register('build');

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        mb: 2,
        display: 'flex',
        gap: 2,
        justifyContent: 'space-between',
        flexWrap: 'wrap',
      }}
    >
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
        <TextField
          label="Locator name or value"
          size="small"
          {...nameOrValueReg}
          onChange={(e) => {
            nameOrValueReg.onChange(e);
            if (onFilterChange) onFilterChange();
          }}
          sx={{ minWidth: 240 }}
        />
        <TextField
          label="Build"
          size="small"
          type="number"
          {...buildReg}
          onChange={(e) => {
            buildReg.onChange(e);
            if (onFilterChange) onFilterChange();
          }}
          sx={{ minWidth: 120 }}
        />
        <Controller
          name="market_id"
          control={form.control}
          render={({ field }) => (
            <Select
              size="small"
              displayEmpty
              sx={{ minWidth: 180 }}
              {...field}
              onChange={(e) => {
                field.onChange(e);
                if (onFilterChange) onFilterChange();
              }}
            >
              <MenuItem value="">All markets</MenuItem>
              {visibleMarkets.map((m) => (
                <MenuItem key={m.id} value={m.id}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <img
                      src={FLAG_MAP[m.id] || PLACEHOLDER_FLAG}
                      alt={`${m.name} flag`}
                      style={{ width: 30, height: 30, marginRight: 8, mixBlendMode: 'multiply' }}
                    />
                    {m.name}
                  </Box>
                </MenuItem>
              ))}
            </Select>
          )}
        />
        <Controller
          name="platform"
          control={form.control}
          render={({ field }) => (
            <Select
              size="small"
              displayEmpty
              sx={{ minWidth: 140 }}
              {...field}
              onChange={(e) => {
                field.onChange(e);
                if (onFilterChange) onFilterChange();
              }}
            >
              <MenuItem value="">All platforms</MenuItem>
              <MenuItem value="android">Android</MenuItem>
              <MenuItem value="ios">iOS</MenuItem>
            </Select>
          )}
        />
        <Controller
          name="page"
          control={form.control}
          render={({ field }) => (
            <PageSelect
              pages={pages}
              placeholder="All pages"
              sx={{ minWidth: 180 }}
              {...field}
              onChange={(e) => {
                field.onChange(e);
                if (onFilterChange) onFilterChange();
              }}
            />
          )}
        />
        <Button variant="outlined" startIcon={<ClearIcon />} onClick={onClear} disabled={loading}>
          Clear
        </Button>
        {resultCount > 0 && (
          <Typography variant="body2" color="text.secondary">
            {resultCount} result{resultCount !== 1 ? 's' : ''}
          </Typography>
        )}
      </Box>
      <Button variant="outlined" startIcon={<AddIcon />} onClick={onOpenCreate}>
        Create Locator
      </Button>
    </Paper>
  );
}
